import { render, staticRenderFns } from "./InvoiceGenerationResult.vue?vue&type=template&id=2fc734be&lang=pug&"
import script from "./InvoiceGenerationResult.vue?vue&type=script&lang=ts&"
export * from "./InvoiceGenerationResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports